import { render, staticRenderFns } from "./ForwardBackward.vue?vue&type=template&id=587d7f5e&scoped=true&"
import script from "./ForwardBackward.vue?vue&type=script&lang=js&"
export * from "./ForwardBackward.vue?vue&type=script&lang=js&"
import style0 from "./ForwardBackward.vue?vue&type=style&index=0&id=587d7f5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d7f5e",
  null
  
)

export default component.exports